import { atom } from "recoil";
export const surveyStateAtom = atom({
  key: "surveyStateAtom", // unique ID (with respect to other atoms/selectors)
  default: { loading: false, error: "", open: false }, // default value (aka initial value)
});
